var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-widget" },
    [
      _c(
        "v-layout",
        { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
        [
          _c("strong", [
            _vm._v(
              _vm._s(_vm.$t("orderType")) +
                ": " +
                _vm._s(_vm.orderType ? _vm.$t("MPS") : _vm.$t("generalOrder"))
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.storeName
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
            [
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.$t("storeName")) + ": " + _vm._s(_vm.storeName)
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.orderId
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("orderId")) + ": " + _vm._s(_vm.orderId))
              ]),
              _vm._v(" "),
              _vm.messages && _vm.messages.length
                ? _c(
                    "v-icon",
                    {
                      attrs: { color: "info", small: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showErrorPopup.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("info")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.buyerName
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("buyerName")) + ": " + _vm._s(_vm.buyerName)
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.platform
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("platform")) + ": " + _vm._s(_vm.platform))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.orderStatus
        ? _c(
            "v-layout",
            { attrs: { "justify-start": "", wrap: "", "align-start": "" } },
            [
              _c(
                "span",
                { staticStyle: { color: "red", "font-weight": "bold" } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("orderStatus")) +
                      ": " +
                      _vm._s(_vm.$t(_vm.orderStatus))
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.messages && _vm.messages.length
        ? _c("LabelErrorPopup", {
            attrs: {
              title: _vm.$t("orderErrorLog"),
              messages: _vm.messages || []
            },
            model: {
              value: _vm.errorPop,
              callback: function($$v) {
                _vm.errorPop = $$v
              },
              expression: "errorPop"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-384fdfbf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384fdfbf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetail.vue
// module id = null
// module chunks = 